module.exports = __webpack_public_path__ + "static/hero-1a7f8b2145ffcc7986aa4c6aa5423881.png";